import APIModel from "../../Models/APIModel";
import axios from "axios";

export const login = params => {
	return axios.post(APIModel.HOST + "User/Authenticate", params, {
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json"
		}
	});
};

export const changeSite = (token, params) => {
	return axios.get(APIModel.HOST + "User/ChangeSite/" + params.SiteID, {
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			token: token
		}
	});
};

export const logout = token => {
	return axios.post(APIModel.HOST + "User/SignOff", null, {
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			token: token
		}
	});
};
